import { cloneDeep, isEmpty } from '@utils/common';

export const sortObjectByKey = (
	arrayOfObjects: Array<Record<string, any>>,
	key: string,
) => {
	if (isEmpty(arrayOfObjects) || !arrayOfObjects) return [];
	if (!key) return arrayOfObjects;

	const clonedArrayOfObjects = cloneDeep(arrayOfObjects);

	return clonedArrayOfObjects.sort((a, b) => {
		if (!a[key] || !b[key]) return arrayOfObjects;

		return a[key].localeCompare(b[key]);
	});
};
